







import { Component, Vue, Prop } from 'vue-property-decorator'
import { NightAction } from '@/class/game'
import { GameState } from '@/enum'
import { Game } from '@/class/game'
import NightActionResultMessages from './NightActionResultMessages.vue'
import NightActionResultCards from './NightActionResultCards.vue'

@Component({
  components: {
    NightActionResultMessages,
    NightActionResultCards
  }
})
export default class NightActionResult extends Vue {
  @Prop() state!: GameState.firstNight | GameState.night
  @Prop() game!: Game
  @Prop() nightAction!: NightAction
  @Prop() playerId!: string
}
